;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/login\",\"regex\":\"^/([^/]+)/login$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/report\",\"regex\":\"^/([^/]+)/report$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.10";import * as Sentry from '@sentry/nextjs';

// Browser errors use the NEXT_PUBLIC_ DSN (inlined into the client bundle at
// build time). No-op when unset. NEXT_PUBLIC_SENTRY_ENVIRONMENT mirrors
// SENTRY_ENVIRONMENT (server side) so preview/production are distinguishable
// in GlitchTip despite sharing one DSN.
Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.1,
  // Routes browser events through our own API route instead of straight to
  // GlitchTip, so ad blockers can't drop them. See app/api/glitchtip-tunnel.
  tunnel: '/api/glitchtip-tunnel',
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
